import { ProcessorDetails } from '@/lib/api/processors';
import { ProcessorHeader } from '../components/processor-header';
import { ProcessorOverviewCard } from '../components/processor-overview-card';
import { ProcessorMetricsCard } from '../components/processor-metrics-card';
import { ConvesioConfigurationCard } from './components/convesio-configuration-card';

interface ConvesioProcessorDetailsPageProps {
  processor: ProcessorDetails;
}

export const ConvesioProcessorDetailsPage = ({ processor }: ConvesioProcessorDetailsPageProps) => {
  return (
    <>
      <ProcessorHeader type="convesio" processor={processor} />
      <ProcessorOverviewCard processor={processor} />
      <ProcessorMetricsCard processor={processor} />
      <ConvesioConfigurationCard processor={processor} />
    </>
  );
};
